import * as v from 'valibot';

const emailSchema = v.object({
  email: v.pipe(
    v.string('Email is required'),
    v.nonEmpty('Email is required'),
    v.email('Please enter a valid email address')
  ),
});

export default emailSchema;
